import { useQuery } from '@tanstack/react-query'
import { getSettings } from '../lib/api'

/** Default disciplines used as fallback before settings load. */
const DEFAULT_DISCIPLINES = ['sales', 'marketing', 'ops']

/**
 * Provides the tenant's configured disciplines list.
 * Falls back to the hardcoded defaults while loading.
 */
export function useDisciplines(): string[] {
  const { data } = useQuery({
    queryKey: ['settings'],
    queryFn: getSettings,
    staleTime: 5 * 60_000, // disciplines rarely change — cache 5 min
  })

  return (data?.disciplines as string[]) ?? DEFAULT_DISCIPLINES
}
